export default "__VITE_ASSET__DhV9V7qI__"